import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router';
import './questionsSearch.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faBooks, faCalculatorSimple, faPenClip } from '@fortawesome/pro-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { useAssignmentContext } from '../assignments/context';
import Modal from '../../components/Modal';
import { useData } from '../assignments/DataContext';

const selectedUrlPaths = ['math_skills_questions'];

const Index = () => {
  const { assignmentId, from, qSetId } = useParams();
  const [items, setItems] = useState([
    {
      id: 1,
      icon: faMagnifyingGlass,
      name: 'Questions Search',
      path: 'castle_questions',
      visible: true
    },
    {
      id: 2,
      icon: faBooks,
      name: 'Castle Reading Sets & Science Clusters',
      path: 'castle_reading_sets',
      visible: true
    },
    {
      id: 3,
      icon: faCalculatorSimple,
      name: 'Math Skills',
      path: 'math_skills',
      visible: true
    },
    {
      id: 4,
      icon: faPenClip,
      name: 'DBQs, Enduring Issue, and Source Writing',
      path: 'dbqSets',
      visible: true
    }
  ]);
  const navigate = useNavigate();
  const [showPendingChangesModal, setShowPendingChangesModal] = useState(false);
  const [initial, setInitial] = useState(true);
  const [conditionalRendering, setConditionalRendering] = useState(false);
  const linkToRef = useRef();
  const selectedAssignment = useAssignmentContext();
  const { courseData, mathSkillCourses } = useData();

  useEffect(() => {
    conditionalRenderingData();
    if (courseData.length > 0 && initial)
      handleMathSkillVisibility();
  }, [window.location.href, courseData]);

  const NavigateToSearchType = (e, item) => {
    e.preventDefault();
    if(from=='qSet')
      linkToRef.current = `${qSetId ? 'qSet/'+ qSetId + '/' : 'qSet/'}${item.path}`;
    else  
      linkToRef.current = `${assignmentId ? 'assignment/'+ assignmentId + '/' : 'assignment/'}${item.path}`;
    if (selectedAssignment.hasPendingChanges) {
      setShowPendingChangesModal(true);
    } else {
      navigate(linkToRef.current);
    }
  };

  const conditionalRenderingData = () => {
    const url = window.location.href;
    const endString = url.substr(url.lastIndexOf('/') + 1);
    selectedUrlPaths.includes(endString)
      ? setConditionalRendering(true)
      : setConditionalRendering(false);
  };

  const handleMathSkillVisibility = () => {
    const courseIds = courseData.map(item => item.id);
    const hasCommonIds = courseIds.some(id => mathSkillCourses.includes(id));
    const updatedItems = items.map(item =>
      item.id === 3 ? { ...item, visible: hasCommonIds } : item
    );
    setItems(updatedItems);
    setInitial(false);
  };

  const manageBackOnClick=()=>{
    if(from=='qSet')
    {
      qSetId? navigate(`/mycontent/questionsets/${qSetId}/questions`) : navigate('/mycontent/questionsets');
    }else{
      assignmentId ? navigate(`/assignments/${assignmentId}/edit_assignment`, { state: { assignedStatus: 4, mcChoices: selectedAssignment?.mcChoices } }) : navigate('/assignments');
    }
  };

  return (
    <>
      <div className={`${conditionalRendering ? 'd-none' : 'd-flex justify-content-end pb-3'}`}>
        <button
          onClick={() => manageBackOnClick()}
          className="btn btn-castleWhite btn-width">
          Back
        </button>
      </div>
      <div className="d-flex flex-column">
        <div className={`${conditionalRendering ? 'd-none' : 'd-flex flex-row justify-content-between gap-3 mb-4'}`}>
          {items.map((item, index) => (
            <>
              {item.comingSoon ? (
                <OverlayTrigger
                  key={`searchTypeToolTipKey${index}`}
                  placement="top"
                  overlay={
                    <Tooltip id={`toolTipId${index}`} className="custom-tooltip">
                      <p className="mb-0">Coming Soon!</p>
                    </Tooltip>
                  }>
                  <a key={`searchType_${index}`} className="questionSearchBtn" to={item.path} disabled >
                    <div className='iconBox'>
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                    {item.name}
                  </a>
                </OverlayTrigger>
              ) : (
                <>
                  {item.visible &&
                    <NavLink key={`searchType_${index}`} className="questionSearchBtn" onClick={(e) => NavigateToSearchType(e, item)} to={`${assignmentId ? assignmentId + '/' : ''}${item.path}`}>
                      <div className='iconBox'>
                        <FontAwesomeIcon icon={item.icon} />
                      </div>
                      {item.name}
                    </NavLink>
                  }
                </>)}
            </>
          ))}

        </div>
        <Outlet />
      </div>

      <Modal
        isOpen={showPendingChangesModal}
        onClose={() => setShowPendingChangesModal(false)}
        contentWidth='40%'>
        <div className='d-flex flex-column'>
          <div>Changing sections will remove your currently selected question(s).  Would you like to continue?</div>

          <div className='d-flex flex-row gap-3 justify-content-end mt-4'>
            <Button variant='castleRed' className='w-25' onClick={() => setShowPendingChangesModal(false)}>No, stay here</Button>
            <Button variant='castleWhite' className='w-25' onClick={() => {
              setShowPendingChangesModal(false);
              navigate(linkToRef.current);
              selectedAssignment.setHasPendingChanges(false);
            }}>Yes</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Index;
